import { Link } from 'gatsby'
import React from 'react'
import Logo from '../../images/logo.svg'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import {} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

library.add(fab)

const Footer = props => {
    const footerNavbar = props.footer
    return (
        <footer className="footer">
            <div className="border" />
            <div className="container">
                <div className="footer__content">
                    <div className="footer__logo">
                        <img src={Logo} alt="Jump" />
                        <p>300 Vesey St, 12th Floor</p>
                        <p>New York, NY 10282, USA</p>
                    </div>
                    <div className="footer__nav">
                        <ul>
                            {footerNavbar.map(item => {
                                if (item.node.title !== `Our Blog`) {
                                    let adress = item.node.title.toLowerCase()
                                    adress = adress.replace(/ /g, `-`)
                                    return (
                                        <li className="nav-list">
                                            <Link to={adress}>
                                                {item.node.title}
                                            </Link>
                                        </li>
                                    )
                                } else {
                                    return (
                                        <li className="nav-list">
                                            <Link to="/">Blog</Link>
                                        </li>
                                    )
                                }
                            })}
                        </ul>
                    </div>
                    <div className="footer__contacts">
                        <p className="footer__contacts-getintouch">
                            Get in touch with us!
                        </p>
                        <p>hello@jump450.com</p>
                        <div className="footer__contacts-social">
                            <div className="social__icon">
                                <i>
                                    <a
                                        href="https://www.facebook.com/jump450/"
                                        target="_blank"
                                    >
                                        <FontAwesomeIcon
                                            icon={[`fab`, `facebook-f`]}
                                        />
                                    </a>
                                </i>
                            </div>
                            <div className="social__icon">
                                <i>
                                    <a
                                        href="https://twitter.com/jump450media"
                                        target="_blank"
                                    >
                                        <FontAwesomeIcon
                                            icon={[`fab`, `twitter`]}
                                        />
                                    </a>
                                </i>
                            </div>
                            <div className="social__icon">
                                <i>
                                    <a
                                        href="https://www.linkedin.com/company/jump-450"
                                        target="_blank"
                                    >
                                        <FontAwesomeIcon
                                            icon={[`fab`, `linkedin-in`]}
                                        />
                                    </a>
                                </i>
                            </div>
                            <div className="social__icon">
                                <i>
                                    <a
                                        href="https://www.instagram.com/jump450media/"
                                        target="_blank"
                                    >
                                        <FontAwesomeIcon
                                            icon={[`fab`, `instagram`]}
                                        />
                                    </a>
                                </i>
                            </div>
                        </div>
                    </div>
                    <div className="footer__copyright">
                        <p>
                            Copyright © 2019 Jump 450 Media LLC. All Rights
                            Reserved.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
